'use strict'

const { create, matchAny } = require('./logger')
const { consoleHandlerCreator } = require('./console')

module.exports = {
  create,
  matchAny,
  consoleHandlerCreator
}
